import { OMS_TENANT, REACT_APP_OMS_URL } from "constants/constants";
import {
  getApiErrorMessage,
  parseFetchResponseBody,
} from "helpers/packageManagementApi";
import { tokenUtils } from "utils";

const buildUrl = (path, searchParams = {}) => {
  const baseUrl = REACT_APP_OMS_URL.replace(/\/$/, "");
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  const url = new URL(normalizedPath, `${baseUrl}/`);

  Object.entries(searchParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, String(value));
    }
  });

  return url;
};

const getHeaders = (token, additionalHeaders = {}) => {
  if (!token) {
    throw new Error("You must be logged in to call OMS APIs.");
  }

  return {
    Accept: "application/json",
    "x-tenant": OMS_TENANT,
    Authorization: `Bearer ${token}`,
    ...additionalHeaders,
  };
};

export const fetchBasicPackagesInfo = async () => {
  const url = buildUrl("/api/packages/get_basic_packages_info");
  const token = tokenUtils.getToken();

  const response = await fetch(url, {
    method: "GET",
    headers: getHeaders(token),
  });

  const data = await parseFetchResponseBody(response);

  if (!response.ok) {
    throw new Error(
      getApiErrorMessage(
        data,
        "Failed to fetch package information from OMS.",
        response.status
      )
    );
  }

  if (data.status === true || data.status === "success") {
    return data.data ?? [];
  }

  throw new Error(
    getApiErrorMessage(
      data,
      "Failed to fetch package information.",
      response.status
    )
  );
};
